<template>
  <img
    :alt="product.title"
    :src="imageSrc"
    @error="loadPlaceholder"
  >
</template>
<script>
  import { ImageType } from '@/shared/enums';
  import { imageCoverMixin } from '@/index/shared/mixins';

  export default {
    name: 'VProductImage',
    mixins: [
      imageCoverMixin,
    ],
    props: {
      product: Object,
      type: {
        type: String,
        default: ImageType.COVER_MINI,
      },
    },
  };
</script>
